import {Component, OnInit, Output, EventEmitter, Input, Inject, PLATFORM_ID, OnChanges, SimpleChanges} from '@angular/core';
import {SessionStorageManager} from 'src/app/data/manager/session-storage/session-storage.manager';
import {DepartmentsVm} from 'src/app/view-model/nav-departments/nav-departments.vm';
import {isPlatformBrowser} from '@angular/common';
import {SessionEvent} from '../../../event-listeners/session/session.event';
import {FormatUrlService} from '../../../utilities/format/format-url.service';
import {LazyLoadImageService} from '../../../services/lazy-load-image/lazy-load-image.service';
import {PageEvent} from '../../../event-listeners/event-page/event-page.event';
import {CountryConfigEvent} from '../../../event-listeners/country-config-event/country-config-event';
import { countryConfig } from 'src/country-config/country-config';
import { NavigationEnd, Router } from '@angular/router';
import { LocalStorageManager } from 'src/app/data/manager/local-storage/local-storage.manager';
import { PrimeEvent } from '../../../event-listeners/prime/prime.event';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { Subscription } from 'rxjs';
import { UpdateNavbarEvent } from '../../../event-listeners/update-navbar/update-navbar.event';

@Component({
  selector: 'app-departments',
  templateUrl: './departments.component.html',
  styleUrls: ['./departments.component.scss'],
})
export class DepartmentsComponent implements OnInit, OnChanges {
  @Input() disableSas;
  arrayDepartments: any[] = [
    {name: 'Salud y medicamentos', id: '1', nameUrl: 'salud-y-medicamentos', primaryColor: '#84D24C'},
    {name: 'Belleza', id: '72', nameUrl: 'belleza', primaryColor: '#B14497'},
  ];
  hide: boolean;
  departmetUrl;
  department: any;
  category: Array<any>;
  colorDepartment: string;
  activeDepartment = {
    'Salud y medicamentos': false,
    Belleza: false,
    'Cuidado del bebé': false,
    'Cuidado personal': false,
    'Alimentos y bebidas': false,
    'Hogar, mascotas y otros.': false,
  };
  image = [];
  imagesUrl = {};
  categoryNav;
  auxGet = 0;
  setColor;
  @Output() emitCuponModal = new EventEmitter<any>();
  @Output() emitNavColor = new EventEmitter<any>();
  statusCuponModal = {open: false};
  departmentLatest = '';
  showContent = false;
  configModule: any;
  isBrowser;
  isPrime: boolean = false;
  primeConfig: any;
  disabledPrime;
  primeSubscription;
  public customer;
  primeConfigSubscription: Subscription;
  departament;
  setHEaderSubscriber: Subscription;
  @Input() setColorHome;
  countEventsTalon = 0;

  constructor(private vm: DepartmentsVm,
              private format: FormatUrlService,
              private ssm: SessionStorageManager,
              private loginEvent: SessionEvent,
              private lazyService: LazyLoadImageService,
              private configCountry: CountryConfigEvent,
              private eventPage: PageEvent,
              private router: Router,
              private lsm: LocalStorageManager,
              private store: Store<AppState>,
              private primeEvent: PrimeEvent,
              private updateNavbarEvent: UpdateNavbarEvent,
              @Inject(PLATFORM_ID) platformId) {
    fetch('/assets/json/deparments.json').then(res => res.json()).then(res => {
      this.arrayDepartments = res;
    });
    this.isBrowser = isPlatformBrowser(platformId) && !(navigator.userAgent.indexOf('Chrome-Lighthouse') > -1);
    this.eventPage.eventPageListener.subscribe((res: any) => {
     if (res.services || countryConfig.getService) {
       this.getAllServices();
     }
    });
    this.configCountry.getCountryConfig.subscribe((config: any) => {
      if (config.general) {
        this.configModule = config.general;
      }
    });
    this.loginEvent.hasCustomer.subscribe(response => {
      this.customer = this.lsm.get("customer");
      this.isPrimeActive();
    });
  }

  getDepartments() {
    this.vm.getDepartments()
      .subscribe((res: any) => {
      this.arrayDepartments = res.departmentList;
      this.arrayDepartments = this.format.deparments(this.arrayDepartments);
      this.arrayDepartments.forEach(department => {
        this.department = department;
        const departamentImages = [];
        for (const index of department.children) {
          if (index.categoryPhoto) {
            this.activeDepartment[department?.name] = true;
            departamentImages.push(index.categoryPhoto);
          }
        }
        this.imagesUrl[department?.name] = departamentImages;
        this.department.children = department.children.sort((a, b) => (b && b.name ? b.name.localeCompare(a.name) : a));
        this.department.children.reverse();
        return department;
      });

      if (this.isBrowser) {
        this.lazyService.lazyLoad();
      }

      this.arrayDepartments.forEach(item => {
        const it = item;
        switch (item.primaryColor) {
          case '#84D24C':
            it.classColor = 'green';
            break;
          case '#B14497':
            it.classColor = 'purple';
            break;
          case '#14C5C7':
            it.classColor = 'light-blue';
            break;
          case '#63428F':
            it.classColor = 'dark-purple';
            break;
          case '#418FDE':
            it.classColor = 'blue';
            break;
          default:
            break;
        }
        return it;
      });
    });
  }

  ngOnInit() { 
    this.updateNavbarEvent.updatedColorNavbarHome.subscribe( color => {
      this.setHEaderSubscriber = this.store.select( 'setHeader' ).subscribe( ({data}) => {
        this.colorDepartment =  ( data?.active ) ?  data?.config.header_secondary_color : '#418fde';
      });
    })
    this.closeCategory();
    this.router.events
    .subscribe((events: any) => {
      this.departament = events?.snapshot?.params?.deparment;
      this.category = events?.snapshot?.params?.categorie;      
      if (events instanceof NavigationEnd ) {
        if ( events.url.search('categorias') === -1) {
          this.setHEaderSubscriber = this.store.select( 'setHeader' ).subscribe( ({data}) => {
            this.colorDepartment =  ( data?.active ) ?  data?.config.header_secondary_color : '#418fde';
          });
        }else{
          if(events.url.split('/')[2]){
            this.countEventsTalon ++;
            const departmentNav = events.url.split('/')[2];
            const department: any = this.arrayDepartments.filter( dep => dep.nameUrl === departmentNav );
            this.setChangeColor( department[0] );
          }
        }
      }
    });
    this.store.select('primeSubs').subscribe(({sub}) => {
      this.primeSubscription = sub;
      this.validateSubscription(sub?.expirationDate);
    });
    this.primeConfigSubscription = this.store.select( 'prime' ).subscribe( ({config}) =>  this.primeConfig = config[0] );
    this.isPrimeActive();
    this.primeEvent.getPrimeUser.subscribe(res =>{
      if(res?.update){
        this.ssm.removeItem( 'primeSubscription' );
        this.isPrimeActive();
      }
    })
  }

  async isPrimeActive() {
    this.vm.getPrimeSubscription(this.customer).subscribe( res =>{
      this.primeSubscription = res;
      this.validateSubscription( (res.expirationDate) ? res.expirationDate : '' );
    });
  }

  validateSubscription( expirationDate ){
    if(expirationDate){
      const today = new Date().getTime();
      ( expirationDate >= today) ? this.isPrime = true : this.isPrime = false;
    }
    if (this.primeConfig && !this.primeConfig.feature_active_web && !this.isPrime) {
      this.disabledPrime = true;
    } else {
      this.disabledPrime = false;
    }
  }


  getPrimeConfig() {
    this.vm.getPrimeConfig().then(  res =>{
      this.primeConfig = res[0];
    });
  }

  getAllServices() {
    this.showContent = true;
    this.getDepartments();
    this.loginEvent.hasCustomer.subscribe(response => {
      if (response.status) {
        this.getDepartments();
      }
    });
  }

  closeCategory() {
    this.hide = false;
  }

  openCategory() {
    this.hide = true;
  }

  setEmiterCoupon() {
    this.statusCuponModal = {open: true};
    this.emitCuponModal.emit(this.statusCuponModal);
  }

  setChangeColor(department, category?) {
    if(this.countEventsTalon === 1){
      this.talonOneEvent(department?.name, category);
    }
    this.colorDepartment = department?.primaryColor;
  }

  isOtherCategory(): boolean {
    return this.configModule?.coupons || this.configModule?.programAndSave;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.disableSas) {
      this.disableSas = changes.disableSas.currentValue;
    }
  }

  talonOneEvent(departament, categorie?){
    let user = this.lsm.get('customer')
    if(departament){
      let data = {
        "idCustomerWebSafe":user?.idCustomerWebSafe ,
        "token":user?.token?.token,
        "tokenIdWebSafe": user?.token?.tokenIdWebSafe ,
        "profileId": user?.analyticsUUID ? user?.analyticsUUID  : 'anonymous',
        "type": "Department_viewed",
        "attributes": {
          "name" : departament
          }
      }
      this.vm.sendEventTalonOne(data).subscribe(res=> res)
    }
    if(categorie){
      let data = {
        "idCustomerWebSafe":user?.idCustomerWebSafe ,
        "token":user?.token?.token,
        "tokenIdWebSafe": user?.token?.tokenIdWebSafe ,
        "profileId": user?.analyticsUUID ? user?.analyticsUUID  : 'anonymous',
        "type": "Category_viewed",
        "attributes": {
          "name" : categorie
          }
        }
        this.vm.sendEventTalonOne(data).subscribe(res=> res)
    }
  }
}
